import api from '@/api'
// get influencer rating datas from database
export default {
  getAllCampaignsNoStatus() {
    return new Promise(function (resolve, reject) {
      api
        .request('get', '/api/v1/campaigns/all?limit=999', true)
        .then(response => {
          if (response.status !== 200) {
            reject(response)
            return
          }

          resolve(response.data)
        })
        .catch(error => {
          // Request failed.
          reject(error)
        })
    })
  },
  getInfluencerAvgRating(filters) {
    return new Promise(function(resolve, reject) {
      const params = Object.keys(filters)
      .map(key => `${key}=${filters[key]}`)
      .join('&')
      api
        .request('get', `/api/v1/payments/influencerAvgRating?${params}`, true)
        .then(response => {
          if (response.status !== 200) {
            reject(response)
            return
          }
          resolve(response.data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  getClientAvgRatings(filters) {
    return new Promise(function(resolve, reject) {
      const params = Object.keys(filters)
      .map(key => `${key}=${filters[key]}`)
      .join('&')
      api
        .request('get', `/api/v1/campaigns/clientAvgRatings?${params}`, true)
        .then(response => {
          if (response.status !== 200) {
            reject(response)
            return
          }
          resolve(response.data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  getTotalReportAbuse(filters) {
    return new Promise(function(resolve, reject) {
      const params = Object.keys(filters)
      .map(key => `${key}=${filters[key]}`)
      .join('&')
      api
        .request('get', `/api/v1/posts/reportAbuseTotal?${params}`, true)
        .then(response => {
          if (response.status !== 200) {
            reject(response)
            return
          }
          resolve(response.data)
        })
        .catch(error => {
          reject(error)
        })
    })
  }
}



// WEBPACK FOOTER //
// ./src/components/views/DashboardComponents/QualityRatingHelper.js